// just a demo set up for positioning
:host {
  width: 100%;
  display: flex;
  flex-direction: var(--placement-direction);
}

.chart-component {
  overflow: auto;
  width: var(--chart-width);
  height: var(--chart-height);
}

.chart-config {
  overflow: auto;
  width: var(--config-width);
  height: var(--config-height);
}
